import type { Me } from './auth';

// Permisos del usuario para mostrar u ocultar opciones. Solo es comodidad: el control real lo hace la API.

/** Con organización: el permiso en esa organización. Sin ella: en alguna de sus organizaciones. */
export function can(me: Me, key: string, organizationId?: string): boolean {
  if (organizationId) return me.permissions[organizationId]?.includes(key) ?? false;
  return Object.values(me.permissions).some((keys) => keys.includes(key));
}

/** Unión de los permisos en todas sus organizaciones (lo que puede conceder al definir un rol). */
export function permissionUnion(me: Me): Set<string> {
  return new Set(Object.values(me.permissions).flat());
}

/** Organizaciones donde tiene el permiso. */
export function orgsWith(me: Me, key: string): string[] {
  return Object.entries(me.permissions)
    .filter(([, keys]) => keys.includes(key))
    .map(([org]) => org);
}
